// Настройки браузера (язык и тема до входа). Доступ к localStorage может
// бросать (приватный режим) — поэтому всегда через try/catch.
export interface KeyValueStorage {
  get(key: string): string | null;
  set(key: string, value: string): void;
}

export class BrowserStorage implements KeyValueStorage {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Без хранилища настройка просто не переживёт перезагрузку.
    }
  }
}

export class MemoryStorage implements KeyValueStorage {
  private readonly values = new Map<string, string>();

  get(key: string): string | null {
    return this.values.get(key) ?? null;
  }

  set(key: string, value: string): void {
    this.values.set(key, value);
  }
}
